import axios, { AxiosInstance, AxiosRequestConfig } from "axios";
import { IChatRequest } from "../interfaces/chatBotInterfaces";
import { IChatBotApi } from "../interfaces/apiInterface";

export class ChatBotApi implements IChatBotApi {
  public readonly axios: AxiosInstance;

  constructor(private apiURL: string) {
    //logEvent(`Initializing`, "UnifiedPortalAPI", this.upEndpoint);
    this.axios = axios.create({
      withCredentials: true,
      withXSRFToken: false,
      allowAbsoluteUrls: false,
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private send = async <T = any>(request: AxiosRequestConfig) => {
    return this.axios.request<T>(request);
  };

  public ask(request: IChatRequest) {
    return this.send({
      method: "POST",
      url: `${this.apiURL}/api/v1/chat`,
      data: request,
    } as AxiosRequestConfig);
  }
}
